import {action, computed, observable} from 'mobx';
import {getStorage} from '../../../utils/storageHelper';
import {getId, getUser, isGuest, isTeacher, setPreviewShowed, setUserInfo} from '../../../utils/userUtility';
import {actions, category, events, OnboardingStepTypes} from '../../../constants/enums';
import {customEvent} from '../../../utils/analyticsUtil';
import {go} from '../../../utils/navigationUtility';
import projectStore from '../../main/project/store';
import {HOW_DO_YOU_TEACH, HOW_MANY_STUDENTS, INSTRUMENTS_LIST, ONBOARDING_ROLE, onboardingInstruments} from '../../../constants/constants';

export const MUSICO_ONBOARDING_ANSWERS = 'musico-onboarding-answers';

class OnBoardingStore {
    @observable finishOnBoarding = true;
    @observable step = 0;
    @observable forceShowWelcome = getStorage().getItem('test-musico-guide') === 'true';

    @observable onboardingAnswers = {};

    constructor() {
        setTimeout(() => {
            this.init();
        })
    }

    projectId = null;

    @observable form = {
        howManyStudents: [{
            value: '1-10',
            label: 'onboarding.howmanystudents.small',
            selected: false
        }, {
            value: '11-20',
            label: 'onboarding.howmanystudents.medium',
            selected: false
        }, {
            value: '21-30',
            label: 'onboarding.howmanystudents.large',
            selected: false
        }, {
            value: '31+',
            label: 'onboarding.howmanystudents.school',
            selected: false
        }],
        howDoYouTeachList: [{
            value: 'online',
            label: 'onboarding.howdoyouteach.online',
            selected: false
        }, {
            value: 'hybrid',
            label: 'onboarding.howdoyouteach.hybrid',
            selected: false
        }, {
            value: 'inperson',
            label: 'onboarding.howdoyouteach.inperson',
            selected: false
        }
        ],
        instruments: onboardingInstruments.map((item) => {
            return {
                label: `upload.form.instruments.${item.name}`,
                value: item.name,
                selected: false
            };
        }),
        onboardingRole: [{
            value: 'individual',
            label: 'onboarding.role.individual',
            selected: false
        }, {
            value: 'schoolTeacher',
            label: 'onboarding.role.schoolTeacher',
            selected: false
        }, {
            value: 'schoolOwner',
            label: 'onboarding.role.schoolOwner',
            selected: false
        }, {
            value: 'other',
            label: 'onboarding.role.other',
            selected: false
        }],
    };

    @computed
    get showOnboarding() {
        return isTeacher() && !isGuest() && (!getUser().showPreview || this.forceShowWelcome);
    }

    isValidStep = (stepType) => {
        switch (stepType) {
            case OnboardingStepTypes.OnboardingHowDoYouTeachStep:
                return this.form.howDoYouTeachList.some(item => item.selected);
            case OnboardingStepTypes.OnboardingInstrumentStep:
                return this.form.instruments.some(item => item.selected);
            case OnboardingStepTypes.OnboardingHowManyStudents:
                return this.form.howManyStudents.some(item => item.selected);
            default:
                return true;
        }
    }

    @action setStep = (val) => {
        this.step = val;
    };

    @action updateCookie = () => {
        const {instruments, howDoYouTeachList, howManyStudents, onboardingRole} = this.form;
        this.onboardingAnswers = {
            instruments: instruments.filter(h => h.selected).map(h => h.value),
            howDoYouTeachList: howDoYouTeachList.filter(h => h.selected).map(h => h.value),
            howManyStudents: howManyStudents.filter(c => c.selected).map(c => c.value),
            onboardingRole: onboardingRole.filter(c => c.selected).map(c => c.value)
        };

        getStorage().setItem(MUSICO_ONBOARDING_ANSWERS, JSON.stringify(this.onboardingAnswers));
    };

    @action init = () => {
        this.onboardingAnswers = JSON.parse(getStorage().getItem(MUSICO_ONBOARDING_ANSWERS) || '{}') || {};
        Object.keys(this.form).map(key => {
            this.form[key].map(item => {
                if (this.onboardingAnswers[key]) {
                    let answer = this.onboardingAnswers[key].find(value => value === item.value);
                    if (answer) {
                        item.selected = true;
                    }
                } else {
                    item.selected = false;
                }
            })
        });
    }

    selectOption = (item) => action(() => {
        item.selected = !item.selected;
        this.updateCookie();
    });

    selectSingleOption = (changeItem, list) => action(() => {
        list.map(item => {
            if (changeItem === item) {
                changeItem.selected = !item.selected;
            } else {
                item.selected = false;
            }
        });
        this.updateCookie();
    });

    getList = (type) => {
        switch (type) {
            case HOW_DO_YOU_TEACH:
                return this.form.howDoYouTeachList;
            case HOW_MANY_STUDENTS:
                return this.form.howManyStudents;
            case INSTRUMENTS_LIST:
                return this.form.instruments;
            case ONBOARDING_ROLE:
                return this.form.onboardingRole
            default :
                return [];
        }
    }

    isOptionSelected = (type) => {
        return this.getList(type).some(el => el.selected);
    }

    selectOptionHandler = (el, type) => {
        const list = this.getList(type);

        this.selectSingleOption(el, list)();
    }


    @action setFinishOnBoarding = (val) => {
        this.finishOnBoarding = val;
    };

    @action submitUserInfo = async () => {
        customEvent(events.CustomEvent, {category: category.OnBoarding, action: actions.OnBoardingDone});
        await setUserInfo(this.onboardingAnswers);
        getStorage().removeItem(MUSICO_ONBOARDING_ANSWERS);
        this.onboardingAnswers = {};
    };

    @action skipWelcome = (student) => {
        this.forceShowWelcome = false;
        setPreviewShowed(true);
        getStorage().removeItem(MUSICO_ONBOARDING_ANSWERS);
        let exitPage = `/home/select/student/${student.id}`;
        if (student && student.id) {
            if (this.projectId) {
                console.log(this.projectId);
                const {id, name, avatar} = student;
                const params = {
                    owner: {id, name, avatar},
                    parentOwnerId: getId(),
                    userId: id,
                    rootProjectId: this.projectId,
                    exitPage: exitPage

                };
                projectStore.createNewStudentLessonFromExisting(this.projectId, params, {action: actions.CreateNewLessonFromDiscover}, false, true);
                return;
            }
            go(exitPage);
        } else {
            go('/home');
        }
    };

    @action
    setProjectId(projectId) {
        this.projectId = projectId;
    }
}

const onBoardingStore = new OnBoardingStore();
export default onBoardingStore;
